// OverallDonut.jsx
import React from "react";
import { PieChart, Pie, Cell } from "recharts";
import { getReadinessColor } from "../utils/readinessUtils";

const OverallDonut = ({ title = "Overall Readiness", value = 0 }) => {
  const roundedValue = Math.round(value);
  const remaining = 100 - roundedValue;

  // Use global readiness utilities
  const getColor = getReadinessColor;

  const data = [
    { name: "Readiness", value: roundedValue, color: getColor(roundedValue) },
    { name: "Remaining", value: remaining, color: "#d1d5db" }, // gray
  ];

  return (
    <div style={{ width: "100%", textAlign: "center", display: "flex", justifyContent: "center" }}>
      

      <PieChart width={160} height={160}>
        <Pie
          data={data}
          innerRadius={55}
          outerRadius={65}
          dataKey="value"
          startAngle={90}
          endAngle={-270}
          isAnimationActive={false}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <text
          x={80}
          y={85}
          textAnchor="middle"
          dominantBaseline="middle"
          className="text-xl font-semibold fill-current text-gray-800"
          style={{ fill: "var(--body-text)" }}
        >
          {roundedValue}%
        </text>
      </PieChart>
    </div>
  );
};

export default OverallDonut;
